function CalcField() {
  return null;
}

export default CalcField;
